export const GET_DETAIL_CHOVAY = "GET_DETAIL_CHOVAY";
export const GET_DETAIL_CHOVAY_SUCCESS = "GET_DETAIL_CHOVAY_SUCCESS";
export const GET_DETAIL_CHOVAY_FAILURE = "GET_DETAIL_CHOVAY_FAILURE";
//Lan Dong Lai
export const GET_LANDONGLAI_CHOVAY = "GET_LANDONGLAI_CHOVAY";
export const GET_LANDONGLAI_CHOVAY_SUCCESS = "GET_LANDONGLAI_CHOVAY_SUCCESS";
export const GET_LANDONGLAI_CHOVAY_FAILURE = "GET_LANDONGLAI_CHOVAY_FAILURE";

export const GET_LAIDENNGAY_CHOVAY = "GET_LAIDENNGAY_CHOVAY";
export const GET_LAIDENNGAY_CHOVAY_SUCCESS = "GET_LAIDENNGAY_CHOVAY_SUCCESS";
export const GET_LAIDENNGAY_CHOVAY_FAILURE = "GET_LAIDENNGAY_CHOVAY_FAILURE";

export const GET_LICHSUGIAHAN_CHOVAY = "GET_LICHSUGIAHAN_CHOVAY";
export const GET_LICHSUGIAHAN_CHOVAY_SUCCESS =
  "GET_LICHSUGIAHAN_CHOVAY_SUCCESS";
export const GET_LICHSUGIAHAN_CHOVAY_FAILURE =
  "GET_LICHSUGIAHAN_CHOVAY_FAILURE";
//POST_GIAHAN_CHOVAY
export const POST_GIAHAN_CHOVAY = "POST_GIAHAN_CHOVAY";
export const POST_GIAHAN_CHOVAY_SUCCESS = "POST_GIAHAN_CHOVAY_SUCCESS";
export const POST_GIAHAN_CHOVAY_FAILURE = "POST_GIAHAN_CHOVAY_FAILURE";

//POST_THAYDOIKYTHANHTOAN_CHOVAY
export const POST_THAYDOIKYTHANHTOAN_CHOVAY = "POST_THAYDOIKYTHANHTOAN_CHOVAY";
export const POST_THAYDOIKYTHANHTOAN_CHOVAY_SUCCESS = "POST_THAYDOIKYTHANHTOAN_CHOVAY_SUCCESS";
export const POST_THAYDOIKYTHANHTOAN_CHOVAY_FAILURE = "POST_THAYDOIKYTHANHTOAN_CHOVAY_FAILURE";
//POST_LICHSUDOIKYLAI_CHOVAY
export const GET_LICHSUDOIKYLAI_CHOVAY = "GET_LICHSUDOIKYLAI_CHOVAY";
export const GET_LICHSUDOIKYLAI_CHOVAY_SUCCESS = "GET_LICHSUDOIKYLAI_CHOVAY_SUCCESS";
export const GET_LICHSUDOIKYLAI_CHOVAY_FAILURE = "GET_LICHSUDOIKYLAI_CHOVAY_FAILURE";

//POST_TRABOTGOC_CHOVAY
export const DELETE_TRABOTGOC_CHOVAY = "DELETE_TRABOTGOC_CHOVAY";
export const DELETE_TRABOTGOC_CHOVAY_SUCCESS =
  "DELETE_TRABOTGOC_CHOVAY_SUCCESS";
export const DELETE_TRABOTGOC_CHOVAY_FAILURE =
  "DELETE_TRABOTGOC_CHOVAY_FAILURE";
export const POST_TRABOTGOC_CHOVAY = "POST_TRABOTGOC_CHOVAY";
export const POST_TRABOTGOC_CHOVAY_SUCCESS = "POST_TRABOTGOC_CHOVAY_SUCCESS";
export const POST_TRABOTGOC_CHOVAY_FAILURE = "POST_TRABOTGOC_CHOVAY_FAILURE";

export const GET_LICHSUTRABOTGOC_CHOVAY = "GET_LICHSUTRABOTGOC_CHOVAY";
export const GET_LICHSUTRABOTGOC_CHOVAY_SUCCESS =
  "GET_LICHSUTRABOTGOC_CHOVAY_SUCCESS";
export const GET_LICHSUTRABOTGOC_CHOVAY_FAILURE =
  "GET_LICHSUTRABOTGOC_CHOVAY_FAILURE";

export const DELETE_VAYTHEM_CHOVAY = "DELETE_VAYTHEM_CHOVAY";
export const DELETE_VAYTHEM_CHOVAY_SUCCESS = "DELETE_VAYTHEM_CHOVAY_SUCCESS";
export const DELETE_VAYTHEM_CHOVAY_FAILURE = "DELETE_VAYTHEM_CHOVAY_FAILURE";
export const POST_VAYTHEM_CHOVAY = "POST_VAYTHEM_CHOVAY";
export const POST_VAYTHEM_CHOVAY_SUCCESS = "POST_VAYTHEM_CHOVAY_SUCCESS";
export const POST_VAYTHEM_CHOVAY_FAILURE = "POST_VAYTHEM_CHOVAY_FAILURE";

export const POST_THAYDOILAISUAT_CHOVAY = "POST_THAYDOILAISUAT_CHOVAY";
export const POST_THAYDOILAISUAT_CHOVAY_SUCCESS =
  "POST_THAYDOILAISUAT_CHOVAY_SUCCESS";
export const POST_THAYDOILAISUAT_CHOVAY_FAILURE =
  "POST_THAYDOILAISUAT_CHOVAY_FAILURE";

export const GET_LICHSUVAYTHEM_CHOVAY = "GET_LICHSUVAYTHEM_CHOVAY";
export const GET_LICHSUVAYTHEM_CHOVAY_SUCCESS =
  "GET_LICHSUVAYTHEM_CHOVAY_SUCCESS";
export const GET_LICHSUVAYTHEM_CHOVAY_FAILURE =
  "GET_LICHSUVAYTHEM_CHOVAY_FAILURE";

export const POST_TATTOAN_CHOVAY = "POST_TATTOAN_CHOVAY";
export const POST_TATTOAN_CHOVAY_SUCCESS = "POST_TATTOAN_CHOVAY_SUCCESS";
export const POST_TATTOAN_CHOVAY_FAILURE = "POST_TATTOAN_CHOVAY_FAILURE";

export const GET_TATTOAN_CHOVAY = "GET_TATTOAN_CHOVAY";
export const GET_TATTOAN_CHOVAY_SUCCESS = "GET_TATTOAN_CHOVAY_SUCCESS";
export const GET_TATTOAN_CHOVAY_FAILURE = "GET_TATTOAN_CHOVAY_FAILURE";
export const GET_LAIDENKY_CHOVAY = "GET_LAIDENKY_CHOVAY";

export const POST_TATTOAN_CHODUYET_CHOVAY = "POST_TATTOAN_CHODUYET_CHOVAY";
export const POST_TATTOAN_CHODUYET_CHOVAY_SUCCESS = "POST_TATTOAN_CHODUYET_CHOVAY_SUCCESS";
export const POST_TATTOAN_CHODUYET_CHOVAY_FAILURE = "POST_TATTOAN_CHODUYET_CHOVAY_FAILURE";
